import React from 'react';
import BrandLogo from './BrandLogo';
import './PaidAdsPage.css';
import { servicePages } from '../data/servicePages';

const paidAdsImages = {
  hero: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/Paid-ads-page/Hero%20Image.png',
  logistics: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/Paid-ads-page/Logistics%20Disruptor.png',
  smartHome: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/Paid-ads-page/Smart%20Home.png',
  funnel: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/Paid-ads-page/funnel.png',
};

const paidAdsData = servicePages.find((service) => service.slug === 'paid-ads');

const sectionTitle = {
  technical: ['The', 'Conversion Logic'],
  showcase: ['Ad', 'Success'],
  clients: ['From our', 'Beloved Clients'],
};

export default function PaidAdsPage() {
  if (!paidAdsData) {
    return null;
  }

  return (
    <div className="pda-page">
      <nav className="pda-nav">
        <BrandLogo className="pda-nav__logo" size="nav" />
        <ul className="pda-nav__links">
          <li>
            <a href="#work">Work</a>
          </li>
          <li>
            <a href="#services">Services</a>
          </li>
          <li>
            <a href="#about">About</a>
          </li>
        </ul>
        <a href="#contact" className="pda-nav__cta">
          Contact
        </a>
      </nav>

      <section className="pda-hero">
        <div className="pda-hero__visual">
          <img
            src={paidAdsImages.hero}
            alt="Paid ads hero"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
        <div className="pda-hero__content">
          <p className="pda-hero__eyebrow">{paidAdsData.eyebrow}</p>
          <h1>
            {paidAdsData.heroTitle[0]}
            <br />
            <em>{paidAdsData.heroTitle[1]}</em>
            <br />
            {paidAdsData.heroTitle[2]}
          </h1>
          <p>{paidAdsData.heroDescription}</p>
          <div className="pda-hero__actions">
            <a href="#work" className="pda-btn pda-btn--dark">
              Explore Styles
            </a>
            <a href="#about" className="pda-btn pda-btn--ghost">
              Our Story Collection
            </a>
          </div>
          <div className="pda-proof">
            {paidAdsData.heroStats.map((item) => (
              <div key={item.label}>
                <strong>{item.value}</strong>
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pda-marquee">
        <div className="pda-marquee__track">
          {[...paidAdsData.marquee, ...paidAdsData.marquee].map((item, index) => (
            <React.Fragment key={`${item}-${index}`}>
              <span>{item}</span>
              <span className="pda-marquee__dot">·</span>
            </React.Fragment>
          ))}
        </div>
      </section>

      <section className="pda-section" id="services">
        <header className="pda-section__header">
          <h2>
            {sectionTitle.technical[0]} <em>{sectionTitle.technical[1]}</em>
          </h2>
        </header>
        <div className="pda-grid pda-grid--services">
          {paidAdsData.services.map((card, index) => (
            <article className="pda-service-card" key={card.title}>
              <p className="pda-service-card__num">{String(index + 1).padStart(2, '0')}</p>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="pda-section" id="work">
        <header className="pda-section__header pda-section__header--showcase">
          <h2>
            {sectionTitle.showcase[0]}
            <br />
            <em>{sectionTitle.showcase[1]}</em>
          </h2>
        </header>
        <div className="pda-grid pda-grid--showcase">
          {paidAdsData.showcase.map((card, index) => (
            <article className="pda-showcase-card" key={card.title}>
              <div className="pda-showcase-card__image">
                <img
                  src={
                    index === 0
                      ? paidAdsImages.logistics
                      : index === 1
                        ? paidAdsImages.smartHome
                        : paidAdsImages.funnel
                  }
                  alt={card.title}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
              <div className="pda-showcase-card__body">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="pda-section" id="about">
        <header className="pda-section__header pda-section__header--clients">
          <p className="pda-section__tag">A Word</p>
          <h2>
            {sectionTitle.clients[0]}
            <br />
            <em>{sectionTitle.clients[1]}</em>
          </h2>
        </header>
        <div className="pda-grid pda-grid--clients">
          {paidAdsData.testimonials.map((quote, index) => (
            <blockquote className="pda-client-card" key={quote}>
              <span className="pda-client-card__mark">"</span>
              <p>{quote}</p>
              <cite>
                <strong>Client {index + 1}</strong>
                <span>BeyonDigital.co</span>
              </cite>
            </blockquote>
          ))}
        </div>
      </section>

      <section className="pda-cta" id="contact">
        <div className="pda-cta__inner">
          <h2>
            Ready for a profitable
            <br />
            <em>scale-up?</em>
          </h2>
          <a href="mailto:sdevarsh54@beyondigital.co.uk" className="pda-btn pda-btn--dark">
            Request a free ad audit
          </a>
        </div>
      </section>

      <footer className="pda-footer">
        <div className="pda-footer__top">
          <div className="pda-footer__brand">
            <BrandLogo size="footer" asLink={false} variant="dark" />
            <p>Turning ad spend into predictable performance growth.</p>
          </div>
          <div className="pda-footer__links">
            <div>
              <h4>Agency</h4>
              <a href="/">About</a>
              <a href="/">Work</a>
              <a href="/">Careers</a>
            </div>
            <div>
              <h4>Services</h4>
              <a href="/">Strategy</a>
              <a href="/">Content</a>
              <a href="/">Paid Social</a>
            </div>
            <div>
              <h4>Connect</h4>
              <a href="https://www.instagram.com/beyondigital.co/">Instagram</a>
              <a href="/">LinkedIn</a>
              <a href="/">Twitter/X</a>
            </div>
          </div>
        </div>
        <div className="pda-footer__bottom">London - India - Dubai</div>
      </footer>
    </div>
  );
}
